
<div class="screen-booking">
	<div class="popup-aside-plain">
		<div class="popup-takeResa" v-loading="loading">
			<div class="header-takeresa">
				<div style="text-align:center">{{ getAllInfos.restoName }}</div>
				<div style="font-weight:100; font-size:14px">
					<div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
					<div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel
					}}</a></div>
				</div>
				<div class="nav-round nav-step" v-if="!showTanks">
					<div v-if="this.formShow === 0">Etape 1/2</div>
					<div v-if="this.formShow === 1 && !getCashInfos">Etape 2/2</div>
					<div v-if="this.formShow === 1 && getCashInfos">Etape 2/3</div>
				</div>
			</div>
			<el-row v-loading="formsLoading" :class="'content-takeresa black-inputs' + this.getClassModifier">
				<el-col :span="20" :offset="2" v-if="this.formOrder[this.formShow] === 'formPart1.data'">
					<el-form ref="formPart1.data" :rules="rulesFormPart1" :model="formPart1.data" label-width="0px">
						<el-form-item>
							<el-radio-group v-model="formPart1.data.civ">
								<el-radio-button label="M."></el-radio-button>
								<el-radio-button label="Mme"></el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item prop="name">
							<el-input v-model="formPart1.data.name" placeholder="Nom*"></el-input>
						</el-form-item>
						<el-form-item prop="prenom">
							<el-input v-model="formPart1.data.prenom" placeholder="Prénom*"></el-input>
						</el-form-item>
						<el-form-item prop="email">
							<el-input v-model="formPart1.data.email" placeholder="e-mail*"></el-input>
						</el-form-item>
						<el-form-item prop="telPreFix" class="tel-prefix">
							<el-input v-model="formPart1.data.telPreFix" placeholder="+33"></el-input>
						</el-form-item>
						<el-form-item prop="tel" class="tel">
							<el-input v-model="formPart1.data.tel" placeholder="Téléphone*"></el-input>
						</el-form-item>
						<el-form-item>
							<el-input v-model="formPart1.data.societe" placeholder="Société"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="18" :offset="3" v-if="this.formOrder[this.formShow] === 'formPart2.data'">
					<div v-if="this.getSelectedMainServiceData === undefined" style="text-align: center">
						Aucun service n'a été paramétré.<br />
						Merci de paramétrer au moins un service dans votre restaurant.
					</div>
					<el-form v-else ref="formPart2.data" :rules="rulesFormPart2" :model="formPart2.data"
						label-width="120px">
						<el-form-item>
							<calendar-nav :checkVisibility="true" />
						</el-form-item>
						<el-form-item v-loading="this.getSelectedService === undefined && !allServiceIsLock">
							<el-input-number v-if="this.getSelectedService && !allServiceIsLock"
								class="text-centered" size="medium" :min="this.getSelectedService.nbMinByResa"
								:max="this.getSelectedService.nbMaxByResa" v-model="formPart2.data.nbCouvert"
								@change="nbCouvUpdate"></el-input-number>
						</el-form-item>
						<el-form-item v-loading="loadingHours">
							<div class="popup-takeResa-dayClosed" v-if="getServicesHours === null && !complet">Fermé
							</div>
							<div class="popup-takeResa-dayClosed" v-if="complet">Complet</div>
							<div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && !limitInterval">Service
								fermé</div>
							<div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && limitInterval">Votre
								réservation est trop importante pour ce créneau horaire.</div>
							<el-select v-if="getServicesHours !== null && !complet && !allServiceIsLock"
								@change="setSelectedService" class="text-centered" v-model="formPart2.data.date2"
								value-key="id" placeholder="Choisissez une heure">
								<el-option-group v-for="ms in getServicesHoursData" :key="ms.label"
									:label="ms.label" v-if="ms.tab.length > 0">
									<el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
									</el-option>
								</el-option-group>
							</el-select>
							<div v-if="getCashInfos && cashInfos && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert))"
								class="popup-takeResa-cash">
								Réservation avec {{ getCashTerme }} de {{ cashInfos.value }}€ par couvert <br> soit
								{{ Math.round(cashInfos.value * formPart2.data.nbCouvert * 100) / 100 }} €.
							</div>
						</el-form-item>
						<el-form-item>
							<el-input v-model="formPart2.data.commentResa" :autosize="{ minRows: 3 }"
								type="textarea" placeholder="Ajouter un commentaire"></el-input>
						</el-form-item>
						<el-form-item prop="allergen">
							<div>
								<el-radio-group v-model="formPart2.data.allergen"
									@change="$refs['formPart2.data'].clearValidate()">
									<el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune
										intolérance ou allergie pour l’ensemble des convives</el-radio>
									<el-radio style="white-space: normal; padding:5px 10px"
										:label="true">Intolérance / Allergie </el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
						<el-form-item v-if="formPart2.data.allergen" prop="allergenMessage">
							<el-input v-model="formPart2.data.allergenMessage" :autosize="{ minRows: 3 }"
								type="textarea"
								placeholder="Merci de renseigner les intolérances / allergies"></el-input>
						</el-form-item>
						<el-form-item
							v-if="getAllInfos.restoBookingMessage && getAllInfos.restoBookingMessage !== ''">
							<div class="bookingMessage">
								<i class="el-icon-info bookingMessage-icon"></i>
								<span class="bookingMessage-text"
									v-html="renderMarkdown(getAllInfos.restoBookingMessage)"></span>
							</div>
						</el-form-item>
					</el-form>
				</el-col>
				<!-- Btn Form 1 -->
				<el-col :span="20" :offset="2" v-if="this.formShow === 0">
					<el-button @click="onSubmitPart1(formOrder[formShow])" type="submit">
						Valider
					</el-button>
				</el-col>
				<!-- Btn Form 2 -->
				<el-col :span="20" :offset="2" v-if="this.formShow === 1">
					<div v-loading="loadingTakeResa">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-button class="dark" type="primary" @click="backForm">Précédent</el-button>
							</el-col>
							<el-col :span="12">
								<el-button v-if="!loadingTakeResa && !complet && !allServiceIsLock"
									:disabled="btnReserverDisabled" type="primary"
									@click="onSubmitPart2(formOrder[formShow])">
									Réserver
								</el-button>
							</el-col>
						</el-row>
					</div>
				</el-col>
				<!-- ML -->
				<el-col :span="20" :offset="2" v-if="this.formShow === 0 || this.formShow === 1">
					<div class="screen-booking-ml">
						<el-collapse v-model="mlActive">
							<el-collapse-item title="Mentions légales & RGPD" name="1">
								<div class="screen-booking-rgpd">
									<div>
										Veuillez cocher les cases ci-dessous si vous acceptez que {{
											getAllInfos.restoName }}
										collecte et utilise les données personnelles que vous venez de renseigner
										dans ce formulaire
										dans le but de vous informer sur ses activités et sa programmation, en
										accord avec notre
										<a href="/download/Politique-de-Protection-des-Donnees.pdf"
											target="_blank">politique de protection des données</a>
									</div>
									<div>par :</div>
									<div class="checkboxes">
										<el-checkbox v-model="rgpdmail">E-mail</el-checkbox>
										<el-checkbox v-model="rgpdsms">SMS</el-checkbox>
									</div>
									<div><a href="/download/CONDITIONS-GENERALES-D-UTILISATION-RESERVATION-EN-LIGNE.pdf"
											target="_blank">En validant ma réservation, je déclare accepter les
											conditions générales d'utilisation du service</a></div>
								</div>
								<br>
								<div>
									Données récoltées via la société RESA.NINJA (RCS Paris 420 442 675) à des fins
									d'informations relatives à la réservation (confirmation, annulation, demandes
									d'avis), relatives à l’enseigne {{ getAllInfos.restoName }}. Les données
									récoltées pourront être croisées avec celles d’ores et déjà détenues par
									l'enseigne {{ getAllInfos.restoName }}.
									Conformément à la loi Informatique et Liberté du 6 Janvier 1978 et modifiée en
									2004, vous disposez d’un droit d’accès, de rectification et de suppression des
									données vous concernant. Pour exercer ces droits, il vous suffit d’en faire la
									demande auprès du service client par courrier à l’adresse suivante : RESA.NINJA
									- Service Marketing – 11, rue des Emeraudes - 69006 LYON.
									Les données récoltées sont conservées dans les conditions de durée prévues par
									la norme simplifiée n°48 de la CNIL.
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</el-col>
				<el-col class="step3" :span="18" :offset="3" v-if="showTanks && !getAllInfos.restoAutoAccept">
					<br>
					<div>Votre réservation a été soumise au restaurateur.</div>
					<br>
					<div>Une fois votre réservation validée un email de confirmation vous sera envoyé.</div>
					<br>
					<div>IMPORTANT: Si vous ne recevez pas nos emails, merci de vérifier vos spams ou l'onglet
						Promotions sur Gmail.</div>
					<br>
					<div>Bonne journée !</div>
					<br>
					<div></div>
				</el-col>
				<el-col class="step3" :span="18" :offset="3" v-else-if="showTanks && getAllInfos.restoAutoAccept">
					<br>
					<p v-if="getAllInfos.resaConfirmMessage">
						{{ getAllInfos.resaConfirmMessage }}
					</p>
					<p v-else>
						Bravo ! <br />Votre réservation est acceptée par le restaurateur.
					</p>
					<br>
					<div>Nous vous attendons donc le {{ getSelectedDay.labelDay }} {{ getSelectedDay.day }}
						{{ getSelectedDay.labelMonth }} {{ getSelectedDay.year }} à {{ formPart2.data.date2.hour }}
						pour
						{{ formPart2.data.nbCouvert }} couvert(s). </div>
					<br>
					<div>Bonne journée !</div>
					<br>
					<div></div>
				</el-col>
			</el-row>
		</div>
	</div>
</div>
